import * as React from 'react';

import { Image } from '../styled';

interface BrandImageProps {
  banner: string | null;
}

export const BrandImage: React.FC<BrandImageProps> = ({ banner }) => {
  if (!banner) {
    return null;
  }

  return <Image src={banner} alt="hair analyser image" />;
};
